import { styled } from '../../shared/theming-sc'

const StyledDateSelectorContainer = styled.div`
  width: 100%;
  min-width: 280px;
`

export {
  StyledDateSelectorContainer
}
